import { EditorFeature } from '.';

export const StandardFeatures = [
  EditorFeature.Bold,
  EditorFeature.Italic,
  EditorFeature.Underline,
  EditorFeature.OrderedList,
  EditorFeature.UnorderedList,
];
